var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCondoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "building",
    clipPath: "url(#clip0_76_252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4487 0.654445C30.5981 0.746833 30.7214 0.875845 30.8069 1.02925C30.8925 1.18265 30.9374 1.35536 30.9375 1.53101V32.4685C30.9375 32.742 30.8289 33.0043 30.6355 33.1977C30.4421 33.3911 30.1798 33.4998 29.9062 33.4998H23.7188C23.4452 33.4998 23.1829 33.3911 22.9895 33.1977C22.7961 33.0043 22.6875 32.742 22.6875 32.4685V29.3748H20.625V32.4685C20.625 32.742 20.5164 33.0043 20.323 33.1977C20.1296 33.3911 19.8673 33.4998 19.5938 33.4998H1.03125C0.757746 33.4998 0.495443 33.3911 0.302046 33.1977C0.108649 33.0043 0 32.742 0 32.4685V21.1248C0.000164271 20.9084 0.068368 20.6976 0.194958 20.5221C0.321547 20.3467 0.500111 20.2155 0.705375 20.1471L12.375 16.2573V9.78101C12.375 9.58965 12.4283 9.40207 12.5288 9.23925C12.6293 9.07643 12.7732 8.9448 12.9443 8.85907L29.4443 0.60907C29.6016 0.530295 29.7766 0.493108 29.9524 0.501051C30.1282 0.508993 30.299 0.5618 30.4487 0.654445ZM12.375 18.4311L2.0625 21.8673V31.4373H12.375V18.4311ZM14.4375 31.4373H18.5625V28.3435C18.5625 28.07 18.6711 27.8077 18.8645 27.6143C19.0579 27.4209 19.3202 27.3123 19.5938 27.3123H23.7188C23.9923 27.3123 24.2546 27.4209 24.448 27.6143C24.6414 27.8077 24.75 28.07 24.75 28.3435V31.4373H28.875V3.19957L14.4375 10.4183V31.4373Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.125 23.1875H6.1875V25.25H4.125V23.1875ZM8.25 23.1875H10.3125V25.25H8.25V23.1875ZM4.125 27.3125H6.1875V29.375H4.125V27.3125ZM8.25 27.3125H10.3125V29.375H8.25V27.3125ZM16.5 19.0625H18.5625V21.125H16.5V19.0625ZM20.625 19.0625H22.6875V21.125H20.625V19.0625ZM16.5 23.1875H18.5625V25.25H16.5V23.1875ZM20.625 23.1875H22.6875V25.25H20.625V23.1875ZM24.75 19.0625H26.8125V21.125H24.75V19.0625ZM24.75 23.1875H26.8125V25.25H24.75V23.1875ZM16.5 14.9375H18.5625V17H16.5V14.9375ZM20.625 14.9375H22.6875V17H20.625V14.9375ZM24.75 14.9375H26.8125V17H24.75V14.9375ZM16.5 10.8125H18.5625V12.875H16.5V10.8125ZM20.625 10.8125H22.6875V12.875H20.625V10.8125ZM24.75 10.8125H26.8125V12.875H24.75V10.8125ZM24.75 6.6875H26.8125V8.75H24.75V6.6875Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_76_252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondoBlack);
export default __webpack_public_path__ + "static/media/condo-black.b6cbc16bf887e8d897de2fe6747ec5f0.svg";
export { ForwardRef as ReactComponent };